import React from "react"
// import UseSiteMetadata from "./../hooks/use-site-metadata"
// import { graphql, useStaticQuery } from "gatsby"


const SiteMetadataContext = React.createContext({ path:'test', marketing: {}, metadata: {}, allPageNodes: {} })

export default SiteMetadataContext